/* tslint:disable */

/**
 */
export class MinMax {
    ID_MIN_MAX?: number;
    LIMIT_ITEM?: number;
    LIMIT_MAX?: number;
    LIMIT_MIN?: number;
    DEFAULT_VALUE?: number;
    COMMENT?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/min-max.ts